module.exports = __webpack_public_path__ + "static/rupture-marking-62ec79448dcdc5c67571ad889eedade5.jpg";